import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";
import ColorListLayer from "../components/ColorListLayer";
import ColorModal from "../components/ColorModal";

const ColorPage = () => {
  const [colors, setColors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState(null);

  const fetchColors = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/color`);
      const data = await res.json();
      setColors(data);
    } catch (err) {
      console.log("Error:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchColors();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Colors" />

      {loading ? (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      ) : (
        <ColorListLayer
          data={colors}
          onAdd={() => setModalData({})}
          onEdit={(row) => setModalData(row)}
          onRefresh={fetchColors}
        />
      )}

      <ColorModal
        show={modalData !== null}
        onClose={() => setModalData(null)}
        data={modalData}
        onSaved={fetchColors}
      />
    </MasterLayout>
  );
};

export default ColorPage;
